import { render, staticRenderFns } from "./add-foreign-card.vue?vue&type=template&id=1a6e999a&scoped=true"
import script from "./add-foreign-card.vue?vue&type=script&lang=ts"
export * from "./add-foreign-card.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a6e999a",
  null
  
)

export default component.exports